import React, { useContext } from "react";
import {
    TableCell,
    Button
  } from "@material-ui/core";
import AppContext from "context/Context";

const DataHeaderCell = ({ name, align, dkey  }) => {
  const {
    config: { isDark} } = useContext(AppContext);
  const style = align === 'right' ? {justifyContent: 'right'} : {justifyContent: 'center'}
  return (
    <TableCell
      align={align}
      id="fno-table-header-cell"
      className={["tradingSymbol", "displayName"].includes(dkey) ? "sticky-column-head" : ""}
      style={{ minWidth: ["totalPNL", "unrealizedPNL", "realizedPNL"].includes(dkey)? '18ch': ''}}
    >
       <div
        id="fno-table-header-button"
        key={dkey}
        style={style}
      >
        {name}
      </div>
    </TableCell>
  );
};
export default DataHeaderCell;
